import { render, staticRenderFns } from "./SelectedAssignment.vue?vue&type=template&id=b413d6dc&scoped=true&"
import script from "./SelectedAssignment.vue?vue&type=script&lang=js&"
export * from "./SelectedAssignment.vue?vue&type=script&lang=js&"
import style0 from "./SelectedAssignment.vue?vue&type=style&index=0&id=b413d6dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b413d6dc",
  null
  
)

export default component.exports